import {message} from "antd";
function WS(isLogin) {/// isLogin参数区分登录页面的和通用首页的websocket
    if(isLogin){
        if(window.client){
            window.client.disconnect(function() {
                console.log('client','清除成功！');
            });
        }
        //window.client = window.Stomp.client('ws://mq.precisiongenes.com.cn:15674/ws');/// 使用window全局字段，能够在想要断联的地方实现断联
        window.client = window.Stomp.client('ws://mq.precisiongenes.com.cn:15674/ws');/// 使用window全局字段，能够在想要断联的地方实现断联
        let on_connect = function (x) {
            // /exchange是固定写法， exchange 后面是交换机
            // 参考最下面扩展信息 https://www.jianshu.com/p/ddf23bab0cad
            // var sub_id = client.subscribe("/exchange/ticks-notify/md5id", function(d) {
            let topic_name = "ticks-integral-topic";
            ///topic/<topicName>
            // 对于 SUBCRIBE frame，destination 创建出自动删除的、非持久的 queue 并根据 routingkey 为<topicName>
            // 绑定到 amq.topic exchange 上，同时实现对该 queue 的订阅。对于 SEND frame，
            // 消息会被发送到 amq.topic exchange 中，routingKey 为<topicName>。

            window.client.subscribe("/topic/" + topic_name, function (d) {
                //console.log('client',JSON.parse(d.body));
                //console.log(JSON.parse(d.body));
                //alert(d.body);
                setTimeout(()=>{
                    let userInfo=window.localStorage.getItem('userInfo');
                    if(userInfo){
                        let id=JSON.parse(userInfo).id;
                        let create_time=JSON.parse(userInfo).create_time;
                        let new_create_time=new Date((create_time.split('+')[0]).replace('T',' '));
                        let user=window.hex_md5(id.toString()+new_create_time.valueOf().toString());
                        if(JSON.parse(d.body).uid===user){///uid相等
                            message.info(JSON.parse(d.body).action+' '+JSON.parse(d.body).integral);
                        }
                    }
                },1500)

            });
            // client.send("/queue/topic", {}, "Hello, STOMP");
        };
        let on_error = function () {
            console.log('client','连不上了！');
            setTimeout(()=>{///延迟2秒再次链接websocket
                WS(isLogin)
            },1000);
        };
        //账号  密码  接到消息执行的方法   异常执行方法   路由
        window.client.connect('guest', 'guest', on_connect, on_error, 'ticks-notify');
    }else {
        if( window.client2){
            window.client2.disconnect(function() {
                console.log('client2','清除成功！');
            });
        }
        //window.client2 = window.Stomp.client('ws://mq.precisiongenes.com.cn:15674/ws');
        window.client2 = window.Stomp.client('ws://mq.precisiongenes.com.cn:15674/ws');
        let on_connect = function (x) {
            //console.log(window.client2);
            // /exchange是固定写法， exchange 后面是交换机
            // 参考最下面扩展信息 https://www.jianshu.com/p/ddf23bab0cad
            // var sub_id = client.subscribe("/exchange/ticks-notify/md5id", function(d) {
            let topic_name = "ticks-integral-topic";
            ///topic/<topicName>
            // 对于 SUBCRIBE frame，destination 创建出自动删除的、非持久的 queue 并根据 routingkey 为<topicName>
            // 绑定到 amq.topic exchange 上，同时实现对该 queue 的订阅。对于 SEND frame，
            // 消息会被发送到 amq.topic exchange 中，routingKey 为<topicName>。

            window.client2.subscribe("/topic/" + topic_name, function (d) {
                //console.log('client2',JSON.parse(d.body));
                //alert(d.body);
                let userInfo=window.localStorage.getItem('userInfo');
                if(userInfo){
                    let id=JSON.parse(userInfo).id;
                    let create_time=JSON.parse(userInfo).create_time;
                    let new_create_time=new Date((create_time.split('+')[0]).replace('T',' '));
                    let user=window.hex_md5(id.toString()+new_create_time.valueOf().toString());
                    if(JSON.parse(d.body).uid===user){///uid相等
                        let hash=window.location.hash;
                        if(hash.match('study')&&JSON.parse(d.body).action.match('在线课堂')){//在线课堂
                            message.info(JSON.parse(d.body).action+' '+JSON.parse(d.body).integral);
                        }
                        if(hash.match('tribune')&&JSON.parse(d.body).action.match('发帖')){//论坛
                            message.info(JSON.parse(d.body).action+' '+JSON.parse(d.body).integral);
                        }
                        if(hash.match('tribune')&&JSON.parse(d.body).action.match('签到')){//论坛
                            message.info(JSON.parse(d.body).action+' '+JSON.parse(d.body).integral);
                        }
                    }
                }
            });
            // client.send("/queue/topic", {}, "Hello, STOMP");
        };
        let on_error = function () {
            console.log('client2','连不上了！');
            setTimeout(()=>{///延迟2秒再次链接websocket
                WS(isLogin)
            },1000);
        };
        //账号  密码  接到消息执行的方法   异常执行方法   路由
        window.client2.connect('guest', 'guest', on_connect, on_error, 'ticks-notify');
    }
}
export default WS


/*
import {message} from "antd";
function WS(isLogin) {/// isLogin参数区分登录页面的和通用首页的websocket
    if(isLogin){
        if(window.client){
            window.client.disconnect(function() {
                console.log('清除成功！');
            });
        }
        //window.client = window.Stomp.client('ws://mq.precisiongenes.com.cn:15674/ws');/// 使用window全局字段，能够在想要断联的地方实现断联
        window.client = window.Stomp.client('ws://mq.precisiongenes.com.cn:15674/ws');/// 使用window全局字段，能够在想要断联的地方实现断联
        let on_connect = function (x) {
            // /exchange是固定写法， exchange 后面是交换机
            // 参考最下面扩展信息 https://www.jianshu.com/p/ddf23bab0cad
            // var sub_id = client.subscribe("/exchange/ticks-notify/md5id", function(d) {
            let topic_name = "ticks-integral-topic";
            ///topic/<topicName>
            // 对于 SUBCRIBE frame，destination 创建出自动删除的、非持久的 queue 并根据 routingkey 为<topicName>
            // 绑定到 amq.topic exchange 上，同时实现对该 queue 的订阅。对于 SEND frame，
            // 消息会被发送到 amq.topic exchange 中，routingKey 为<topicName>。

            window.client.subscribe("/topic/" + topic_name, function (d) {
                //console.log('client',JSON.parse(d.body));
                //console.log(JSON.parse(d.body));
                //alert(d.body);
                setTimeout(()=>{
                    let userInfo=window.localStorage.getItem('userInfo');
                    if(userInfo){
                        let id=JSON.parse(userInfo).id;
                        let create_time=JSON.parse(userInfo).create_time;
                        let new_create_time=new Date((create_time.split('+')[0]).replace('T',' '));
                        let user=window.hex_md5(id.toString()+new_create_time.valueOf().toString());
                        if(JSON.parse(d.body).uid===user){///uid相等
                            message.info(JSON.parse(d.body).action+' '+JSON.parse(d.body).integral);
                        }
                    }
                },1500)

            });
            // client.send("/queue/topic", {}, "Hello, STOMP");
        };
        let on_error = function () {
            console.log('连不上了');
            setTimeout(()=>{///延迟2秒再次链接websocket
                WS(isLogin)
            },1000);
        };
        //账号  密码  接到消息执行的方法   异常执行方法   路由
        window.client.connect('guest', 'guest', on_connect, on_error, 'ticks-notify');
    }else {
        if( window.client2){
            window.client2.disconnect(function() {
                console.log('清除成功！');
            });
        }
        //window.client2 = window.Stomp.client('ws://mq.precisiongenes.com.cn:15674/ws');
        window.client2 = window.Stomp.client('ws://mq.precisiongenes.com.cn:15674/ws');
        let on_connect = function (x) {
            //console.log(window.client2);
            // /exchange是固定写法， exchange 后面是交换机
            // 参考最下面扩展信息 https://www.jianshu.com/p/ddf23bab0cad
            // var sub_id = client.subscribe("/exchange/ticks-notify/md5id", function(d) {
            let topic_name = "ticks-integral-topic";
            ///topic/<topicName>
            // 对于 SUBCRIBE frame，destination 创建出自动删除的、非持久的 queue 并根据 routingkey 为<topicName>
            // 绑定到 amq.topic exchange 上，同时实现对该 queue 的订阅。对于 SEND frame，
            // 消息会被发送到 amq.topic exchange 中，routingKey 为<topicName>。

            window.client2.subscribe("/topic/" + topic_name, function (d) {
                //console.log('client2',JSON.parse(d.body));
                //alert(d.body);
                let userInfo=window.localStorage.getItem('userInfo');
                if(userInfo){
                    let id=JSON.parse(userInfo).id;
                    let create_time=JSON.parse(userInfo).create_time;
                    let new_create_time=new Date((create_time.split('+')[0]).replace('T',' '));
                    let user=window.hex_md5(id.toString()+new_create_time.valueOf().toString());
                    if(JSON.parse(d.body).uid===user){///uid相等
                        let hash=window.location.hash;
                        if(hash.match('study')&&JSON.parse(d.body).action.match('在线课堂')){//在线课堂
                            message.info(JSON.parse(d.body).action+' '+JSON.parse(d.body).integral);
                        }
                        if(hash.match('tribune')&&JSON.parse(d.body).action.match('发帖')){//论坛
                            message.info(JSON.parse(d.body).action+' '+JSON.parse(d.body).integral);
                        }
                        if(hash.match('tribune')&&JSON.parse(d.body).action.match('签到')){//论坛
                            message.info(JSON.parse(d.body).action+' '+JSON.parse(d.body).integral);
                        }
                    }
                }
            });
            // client.send("/queue/topic", {}, "Hello, STOMP");
        };
        let on_error = function () {
            console.log('连不上了');
            setTimeout(()=>{///延迟2秒再次链接websocket
                WS(isLogin)
            },1000);
        };
        //账号  密码  接到消息执行的方法   异常执行方法   路由
        window.client2.connect('guest', 'guest', on_connect, on_error, 'ticks-notify');
    }
}
export default WS*/
